import { TDeviceType } from '@cian/ui-kit';

import { SEARCH_LISTING_UXFB_EVENT_NAME, SERP_FILTER_APPLIED_UXFB_EVENT_NAME } from './constants';
import { isUxfbClientEventsEnabled } from './isUxfbClientEventsEnabled';
import { sendUXSEventWhenReady } from './sendUXSEventWhenReady';
import { isSuburban, offerTypeFromJsonQuery } from '../../../packages/JsonQuery';
import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import { EListingModalMode } from '../actions/listingModal';
import { selectIsDesktopListingVisible } from '../selectors/desktopListing';
import { selectModalMode } from '../selectors/listingModal';
import { TThunkAction } from '../types/redux';

export type TUxfbViewMode = 'list' | 'map' | 'hybrid';

export const getUxfbViewMode = (
  deviceType: TDeviceType,
  isDesktopListingVisible: boolean,
  mobileListingModalMode: EListingModalMode,
): TUxfbViewMode => {
  if (deviceType === 'desktop') {
    return isDesktopListingVisible ? 'hybrid' : 'map';
  }

  if (mobileListingModalMode === EListingModalMode.FULL_SCREEN) {
    return 'list';
  }

  if (mobileListingModalMode === EListingModalMode.HALF_SCREEN) {
    return 'hybrid';
  }

  return 'map';
};

interface ISendUxfbEventParameters {
  jsonQuery: IJsonQuery;
  deviceType: TDeviceType;
}

interface ISendUxfbEventParametersInternal extends ISendUxfbEventParameters {
  eventName: string;
  extraParams: Record<string, string>;
}

export const sendUxfbEvent =
  ({ jsonQuery, deviceType, eventName, extraParams }: ISendUxfbEventParametersInternal): TThunkAction =>
  (_dispatch, getState, context) => {
    if (!isUxfbClientEventsEnabled(context.config)) {
      return;
    }

    const state = getState();
    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const mobileListingModalMode = selectModalMode(state);
    const isDesktopListingVisible = selectIsDesktopListingVisible(state);

    sendUXSEventWhenReady(eventName, {
      deal_type: 'rent',
      is_daily: 'yes',
      offer_type: isSuburban(offerType) ? 'suburban' : 'flat',
      platform: deviceType === 'desktop' ? 'desktop' : 'mobweb',
      view_mode: getUxfbViewMode(deviceType, isDesktopListingVisible, mobileListingModalMode),
      ...extraParams,
    });
  };

export const sendSearchListingUxfbEvent = (parameters: ISendUxfbEventParameters): TThunkAction =>
  sendUxfbEvent({
    ...parameters,
    eventName: SEARCH_LISTING_UXFB_EVENT_NAME,
    extraParams: { property_type: 'daily_rent' },
  });

export const sendSerpFilterAppliedUxfbEvent = (parameters: ISendUxfbEventParameters): TThunkAction =>
  sendUxfbEvent({
    ...parameters,
    eventName: SERP_FILTER_APPLIED_UXFB_EVENT_NAME,
    extraParams: { filter_name: 'other', listing_type: 'daily_rent' },
  });
